
export default {
    setNivel(state, data) {
        state.nivel = data
    },
    setNiveis(state, data) {
        state.niveis = data
    }
}